import TokenResource from "./TokenResource";

export default class ApplicationsResource extends TokenResource {
	applicationId = 0;
	applicationNumber = "";
	objectModel = "";
	objectYear = "";
	objectMake = "";
	objectIcon = "";
	objectPrice = null;
	createdDate = null;
	isEsigned = false;
	isDueCompletion = false;
	productName = "";
	applicationStatus = "";
	applicationStatusId = 0;
	imageUrl = "";

	pk() {
		return this.applicationId?.toString() ?? "";
	}

	static getRequestOptions() {
		return {
			invalidIfStale: true,
		};
	}

	static urlRoot = "/api/applications";
}
